<template>
  <div>
    <div v-if="isShowQuote">
      <div @click="backPressed" class="hidden laptop:block cursor-pointer">
        <ul v-if="($route.query.is_from_mobile ?? 0) != '1' && crumbs?.length > 0" class="breadcrumb mb-4">
          <li v-for="(item, index) in crumbs" :key="index"
            class="breadcrumb-item group first:before:!hidden before:!content-['|'] before:!text-[#fff] last:before:!text-[#FE5000]">
            <a class="font-medium no-underline text-[#fff] group-last:text-[#FE5000]"
              @click="crumbClicked(item, index)">{{
                item
              }}</a>
          </li>
        </ul>
      </div>
      <div class="flex flex-col laptop:grid grid-cols-1 laptop:grid-cols-3 gap-4 laptop:items-start">
        <div
          class="p-3 flex flex-col mobile:order-2 laptop:order-none gap-4 w-full rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
              <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
              <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Details</h2>
            </div>
            <button @click="openNotesModal()"
              class="flex items-center gap-2 rounded-full text-[14px] laptop:hidden px-2 py-1.5 bg-[#092E87] text-[#fff]">
              <span>Notes</span>
              <img src="../../assets/images/add-circle.png" class="w-[20px] h-[20px] object-cover">
            </button>
          </div>
          <Notes v-if="notes"></Notes>
        </div>
        <div class="col-span-2 flex flex-col gap-4 w-full">
          <AlertNote v-if="checkNoteAlert()" />
          <div class="p-3 flex flex-col w-full rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
            <TabButtons></TabButtons>
            <div v-if="componentState == 'Notes'">
              <ImageGallery :isBefore="1"></ImageGallery>
            </div>
            <QuoteItems v-if="quoteItems" :no_of_units="no_of_units" ref="refQuoteItems"></QuoteItems>
            <QuoteSummary v-if="componentState == 'QuoteSummary'" :no_of_units="no_of_units"></QuoteSummary>
          </div>

          <div v-if="componentState == 'QuoteSummary' && !isMaintenanceQuote"
            class="p-3 flex flex-col w-full rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
            <CauseOfFailure ref="refCauseOfFailure" />
          </div>
          <div v-if="componentState !== 'QuoteItems' && componentState !== 'QuoteSummary'"
            class="p-3 flex flex-col w-full rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
            <div v-if="quoteDetail != null && quoteDetail.trade.title == 'Hvac'">
              <HvacEquipmentInfo v-if="equipmentInfo"></HvacEquipmentInfo>
            </div>
            <div v-else>
              <EquipmentInfo v-if="equipmentInfo" />
            </div>
          </div>
          <div v-if="componentState == 'QuoteSummary'"
            class="p-3 flex flex-col w-full rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
            <ImageGallery :isBefore="0"></ImageGallery>
          </div>
          <div class="mobile:hidden laptop:block" v-if="componentState == 'QuoteSummary'">
            <QuoteSummaryTotal :validate-before-submit="validateQuoteSummary"
            :save-before-submit="saveCauseOfFailure" />
          </div>
        </div>
        <div class="mobile:block laptop:hidden order-3" v-if="componentState == 'QuoteSummary'">
          <QuoteSummaryTotal :validate-before-submit="validateQuoteSummary"
              :save-before-submit="saveCauseOfFailure" />
        </div>
      </div>
    </div>

    <div class="modal fade modal-md" id="modalMaintenance" ref="modalMaintenance" tabindex="-1"
      data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true" aria-labelledby="exampleModalLabel"
      aria-modal="true" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content maintenanceModal p-0">
          <div class="flex items-center gap-2 px-4 py-4">
            <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
            <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
            <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Units Included for Service</h2>
          </div>
          <div class="modal-body">
            <p class="mb-0 text-center">How many HVAC systems are included for service under this claim? </p>
            <div class="system-options my-4">
              <label class="system-option">
                <input v-model="number_of_units" type="radio" name="system" value="1" checked>
                <div class="card selected">
                  <img src="../../assets/images/outdoor-1.png" alt="1 System">
                </div>
                <p>1 System</p>
              </label>
              <!-- Option 2 -->
              <label class="system-option">
                <input v-model="number_of_units" type="radio" name="system" value="2">
                <div class="card">
                  <img src="../../assets/images/outdoor-2.png" alt="2 System">
                </div>
                <p>2 Systems</p>
              </label>
            </div>
            <div class="flex justify-center pb-2">
              <button @click="nextModalClicked()"
                class="px-4 py-1.5 border-1 rounded-full text-[16px] font-lato transition duration-300 border-[#FE5000] mobile:text-white laptop:text-[#FE5000] mobile:bg-[#FE5000] laptop:bg-white laptop:hover:bg-[#FE5000] laptop:hover:text-[#fff]">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isNotesOpen" id="notesModal" class="modal fade modal-md show bg-opacity-50 bg-[#000]" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog" style="display: block">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content !rounded-[20px]">
          <div class="modal-body p-4 pb-5">
            <div class="flex flex-col gap-4 w-full">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                  <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
                  <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
                  <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Notes</h2>
                </div>
                <button class="w-[40px] h-[40px] p-2 rounded-full bg-opacity-60 bg-[#EFEFEF]" @click="closeModal"
                  type="button" data-bs-dismiss="modal" aria-label="Close">
                  <img src="@/assets/images/modal-cross-icon.png">
                </button>
              </div>
              <noteBox />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Modal } from "bootstrap";
import { nextTick } from 'vue';
import Notes from "@/components/notes/Notes.vue";
import EquipmentInfo from "@/components/quote/EquipmentInfo.vue";
import HvacEquipmentInfo from "@/components/quote/HvacEquipmentInfo.vue";
import QuoteItems from "@/components/quote/QuoteItems.vue";
import QuoteSummary from "@/components/quote/QuoteSummary.vue";
import CauseOfFailure from "@/components/quote/CauseOfFailure.vue";
import TabButtons from "@/components/tab-buttons/TabButtons.vue";
import ImageGallery from "@/components/image_gallery/ImageGallery.vue";
import AlertNote from "@/components/alert_note/AlertNote.vue";
import noteBox from "../../components/notes/noteBox.vue";
import QuoteSummaryTotal from "../../components/quote/QuoteSummaryTotal.vue";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";

export default {
  components: {
    Notes,
    EquipmentInfo,
    HvacEquipmentInfo,
    QuoteItems,
    QuoteSummary,
    CauseOfFailure,
    TabButtons,
    ImageGallery,
    AlertNote,
    noteBox,
    QuoteSummaryTotal
  },

  data() {
    return {
      crumbs: ["Quote Details", "Equipment Info"],
      isShowQuote: false,
      notes: true,
      equipmentInfo: true,
      gallery: true,
      quoteItems: false,
      quoteSummary: false,
      no_of_units: -1,
      is_show_multi_units: false,
      number_of_units: -1,
      isNumberOfUnitsDialogShow: false,
      isNotesOpen: false,
      isFirstTimeSet: false
    };
  },
  computed: {
    ...mapGetters(["quoteDetail", "componentState"]),

    isPartnerQuote() {
      return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
    },

    isMaintenanceQuote() {
      return (this.quoteDetail?.service_type?.title ?? '').toLowerCase() == 'maintenance'
    },
  },

  watch: {
    quoteDetail: function (data) {
      if (data.status.technician.status == 0) {
        this.isShowQuote = true;
      } else {
        this.$router.push({ path: `/quote/detail/${this.quoteDetail.id}` });
      }

      if (!this.isFirstTimeSet) {
        var component = this.isPartnerQuote ? "Notes" : "QuoteItems"
        if ((this.$route.query.is_from_mobile ?? 0) != '1') {
          component = JSON.parse(localStorage.getItem(this.$route.params.id + "-quote")) ?? (this.isPartnerQuote ? "Notes" : "QuoteItems");
        }
        console.log("component  ", component);
        this.setCommponent(component);
        this.setCompoenentState(component)
        this.isFirstTimeSet = true
      }
      if (this.quoteItems && !this.isNumberOfUnitsDialogShow) {
        this.isNumberOfUnitsDialogShow = true
        //  this.no_of_units = this.quoteDetail.number_of_units
        this.number_of_units = this.quoteDetail.number_of_units
        this.is_show_multi_units = this.quoteDetail.partner_info.is_show_multi_units

        if (this.is_show_multi_units) {
          nextTick(() => {
            this.modal = new Modal(this.$refs.modalMaintenance);
            this.modal.show();
            disableScroll()
          })
        }
        else {
            this.no_of_units = this.number_of_units
            if (this.$refs.refQuoteItems) {
              this.$refs.refQuoteItems.setUnits(this.number_of_units)
            }
        }
      } 
      else if (this.no_of_units != -1) {
            this.no_of_units = this.number_of_units
            if (this.$refs.refQuoteItems) {
              this.$refs.refQuoteItems.setUnits(this.number_of_units)
            }
      }
    },

    componentState: function (data) {
      this.setCompoenentState(data)
    },
  },

  mounted() {
    this.getQuoteDetail({
      manual_quote_id: this.$route.params.id,
    });


    this.$refs.modalMaintenance.addEventListener('shown.bs.modal', () => {
      disableScroll()
    });

    this.$refs.modalMaintenance.addEventListener('hidden.bs.modal', () => {
      enableScroll()
    })
  },

  methods: {
    ...mapActions(["setCommponent", "getQuoteDetail"]),
    validateQuoteSummary() {
      return this.$refs.refCauseOfFailure
        ? this.$refs.refCauseOfFailure.validateCauseOfFailure()
        : true;
    },

    saveCauseOfFailure() {
      return this.$refs.refCauseOfFailure
        ? this.$refs.refCauseOfFailure.submitCauseOfFailure()
        : true;
    },

    openNotesModal() {
      disableScroll()
      this.isNotesOpen = true;
    },
    closeModal() {
      enableScroll()
      this.isNotesOpen = false;
    },
    resetCommponent() {
      this.gallery = false;
      this.notes = false;
      this.equipmentInfo = false;
      this.quoteItems = false;
      this.quoteSummary = false;
    },

    nextModalClicked() {
      this.no_of_units = this.number_of_units
      if (this.$refs.refQuoteItems) {
        this.$refs.refQuoteItems.setUnits(this.number_of_units)
      }
      enableScroll()
      this.modal.hide();
    },

    checkNoteAlert() {
      if (this.quoteDetail &&
        this.quoteDetail.partner_info
        && this.quoteDetail.partner_info.show_replacement_opportunity_badge == '1'
        && this.quoteDetail.partner_info.status == '1'
        && this.quoteDetail.partner_info.company_name != 'Vivint'
        && this.quoteDetail.partner_info.replacement_opportunity_number.length > 0) {
        return true
      } else {
        return false
      }
    },

    backButtonClicked() {
      switch (this.componentState) {
        case "QuoteItems":
          this.setCommponent("Notes");
          break;
        case "QuoteSummary":
          this.setCommponent("QuoteItems");
          break;
      }
    },

    crumbClicked(item) {
      if (item == "Equipment Info") {
        this.setCommponent("Notes");
      } else if (item == "Quote Items") {
        this.setCommponent("QuoteItems");
      } else if (item == "Quote Details") {
        this.$router.push({ path: `/quote/detail/${this.quoteDetail.id}` });
      }
    },

    setCompoenentState(data) {
            localStorage.setItem(
        this.$route.params.id + "-quote",
        JSON.stringify(data)
      );
      this.crumbs = [];
      this.crumbs.push("Quote Details");
      if(this.isPartnerQuote) {
        this.crumbs.push("Equipment Info");
      }
      console.log("component  1", data);
      this.resetCommponent();
      
      switch (data) {
        case "Notes":
          this.notes = true;
          this.equipmentInfo = true;
          this.gallery = true;
          break;
        case "QuoteItems":
          this.notes = true;

          this.crumbs.push("Quote Items");
          this.quoteItems = true;
          // if (this.quoteDetail)
          this.getQuoteDetail({
            is_hide: true,
            manual_quote_id: this.$route.params.id,
          });
          break;
        case "QuoteSummary":
          this.notes = true;
          this.quoteSummary = true;
          this.gallery = false
          this.crumbs.push("Quote Items");
          this.crumbs.push("Summary");
          break;
      }
      nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth" // ya "auto"
        });
      })
    } 
  },
};
</script>

<style>
.custom-breadcrumb {
  background-color: #fff;
}

.custom-breadcrumb a {
  margin: 5px 0 0;
  font-weight: 600;
}

.custom-breadcrumb .breadcrumb-item a {
  cursor: pointer;
  color: #ff5b01;
  text-decoration: underline;
}

.custom-breadcrumb .breadcrumb-item:last-child a {
  color: #7e7e7e;
  cursor: default;
  text-decoration: none;
}

.breadcrumbNavigation {
  padding: 1rem 0;
  border-bottom: 1px solid #ccc;
}

.maintenanceModal .modal-header {
  background: #ff5b01;
  border: 0;
  color: #fff;
}

.maintenanceModal .system-options {
  display: flex;
  gap: 20px;
  justify-content: center;
  /* flex-wrap: wrap; */
}

.maintenanceModal .system-option input[type="radio"] {
  display: none;
}

.maintenanceModal .system-option p {
  margin: 1rem 0 0 0;
  text-align: center;
  color: #f44e00;
}

.maintenanceModal .card {
  border: 2px solid transparent;
  border-radius: 10px;
  padding: 15px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.2s ease;
  cursor: pointer;
}

.maintenanceModal .card img {
  width: 150px;
  height: 120px;
  object-fit: contain;
}

.maintenanceModal .card p {
  color: #f44e00;
  font-weight: bold;
  margin-top: 8px;
}

.maintenanceModal .system-option input[type="radio"]:checked+.card {
  border-color: #f44e00;
  box-shadow: none;
}
</style>
